import { render } from "./CNotification.vue?vue&type=template&id=00139fce"
import script from "./CNotification.vue?vue&type=script&lang=js"
export * from "./CNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__